import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const admissionSlides = lazy(() => import('../../container/admissionSlides'));

const AdmissionSlideRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/admissionSlides`} component={admissionSlides}/>
        </Switch>
    );
};

export default AdmissionSlideRoutes;